class ComparisonSlider extends HTMLElement {

  constructor() {
    super()
    this.wrapper = this.querySelector('.comparison-slider__media-wrapper')
    this.handle = this.querySelector('.cs-slider__handle')
    this.orientation = this.wrapper.dataset.orientation || 'horizontal'
    this._onMove = this._onMove.bind(this)
    this._onUp = this._onUp.bind(this)
  }

  connectedCallback() {
    this.update(50)

    // Mouse
    this.handle.addEventListener('mousedown', (e) => {
      e.preventDefault()
      document.addEventListener('mousemove', this._onMove)
      document.addEventListener('mouseup', this._onUp)
    })

    // Touch
    this.handle.addEventListener('touchstart', (e) => {
      e.preventDefault()
      document.addEventListener('touchmove', this._onMove, { passive: false })
      document.addEventListener('touchend', this._onUp)
    }, { passive: false })
  }

  _onMove(e) {
    const rect = this.wrapper.getBoundingClientRect()
    const clientX = e.touches ? e.touches[0].clientX : e.clientX
    const clientY = e.touches ? e.touches[0].clientY : e.clientY

    let value
    if (this.orientation === 'vertical') {
      value = ((clientY - rect.top) / rect.height) * 100
    } else {
      value = ((clientX - rect.left) / rect.width) * 100
    }

    value = Math.min(100, Math.max(0, value))
    this.update(value)
  }

  _onUp() {
    document.removeEventListener('mousemove', this._onMove)
    document.removeEventListener('mouseup', this._onUp)
    document.removeEventListener('touchmove', this._onMove)
    document.removeEventListener('touchend', this._onUp)
  }

  update(value) {
    this.wrapper.style.setProperty('--compare', value)
  }

}

customElements.define('comparison-slider-component', ComparisonSlider)
